var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"agent-container"},[_c('div',{staticClass:"bg-content"}),_c('Header'),_c('AnAgentDetails'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }